<template>
<v-layout row wrap class="" style="overflow: hidden !important;">

  test- {{localtz}}- {{date}} - {{time}}
 
<!-- <link-prevue :url="convertURL('https://chat.one.th/login')">
    <template slot-scope="props">
      {{props}}
      {{props.img}}
      {{props.title}}
      {{props.description}}
        <img style="height: 50px;" :src="props.img" :alt="props.title">

    </template>
  </link-prevue>
 -->


</v-layout>
</template>

<script>
// import LinkPrevue from 'link-prevue'
var moment = require('moment')

export default {
  data: () => ({
    localtz: '',
    date: '',
    time: ''
  }),
  components: {
    // LinkPrevue
  },
  created() {
    this.time = moment().toDate().getTime()
    this.localtz = moment.tz.guess() // user's timezone
    this.date = (moment(this.time).tz(this.localtz).lang('th').format('LT'))

  },
  methods: {
    // convert(msg) {
    //   var linkifyStr = require('linkifyjs/string')
    //   var str = msg
    //   var processedContent = linkifyStr(str)
    //   return processedContent
    // },
    // convertURL (msg) {
    //   var urlRegex = /\bhttps?:\/\/\S+/gi;
    //   if (msg.match(urlRegex) !== null) {
    //     if (msg.match(urlRegex).length !== 0 ) {
    //       return msg.match(urlRegex)[0]
    //     }
    //     return ''
    //   } else {
    //     return ''
    //   }
    //   // console.log(msg.match(urlRegex) !== null);
    // }
  }
}
</script>

<style type="text/css" scoped>
.chat-messages-richmenu {
  padding: 9px !important;
  height: 60px !important;
  width: 50% !important;
  background: #27303e !important;
  bottom: 0 !important;
  position: fixed !important;
}
.chat-messages-richmenu-sheet {
  padding: 9px !important;
  height: 310px !important;
  width: 50% !important;
  background: #27303e !important;
  bottom: 0 !important;
  position: fixed !important;
}
.chat-messages-richmenu-sheet-row {
  padding: 9px !important;
  height: 185px !important;
  width: 50% !important;
  background: #27303e !important;
  bottom: 0 !important;
  position: fixed !important;
}
.text-overflow-quickreply {
  display: block;
  max-width: 20em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text-task-detail {
  color: black !important;
  margin-bottom: 5px !important;
  text-align: left !important;
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}
.test-overflow-chip {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 100px !important;
}
.p-announce {
  cursor: pointer !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.p-announce:hover {
  color: #1b232c !important;
}
.list-announce {
  height: 50px;
  cursor: pointer !important;
}
.list-announce:hover {
  cursor: pointer !important;
  background: #b4d1f478 !important;
}
>>>.v-list {
    /* min-width: 210px !important; */
    max-width: 100% !important;
}
.boxself_createablums {
  text-align: left;
  /*margin: 20px auto;*/
  /*margin-right: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 25vw;
  cursor: pointer;
  /* height: 250px; */
}
.boxother_createablums {
  cursor: pointer;
  text-align: left;
  /* margin: 20px auto; */
  /*margin-left: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  /*margin-top: 0px !important;*/
  float: left;
  max-width: 25vw;
}
.showmention {
  background: #1b232d63 !important;
  margin: 0 !important;
  bottom: 122px !important;
  position: fixed !important;
  width: 50% !important;
  height: 55px !important;
  padding: 5px !important;
}

.scrolling-wrapper {
  display: flex;
  overflow-x: auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  height: 5px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}

.boxself_unsend {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  /*max-width: 170px;*/
  min-height: 18px;
  max-width: 175px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}

.boxother_unsend {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  min-height: 18px;
  max-width: 225px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}

.boxother_system {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  max-width: 300px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;

}

.boxself_system {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  font-size: 13px;
  max-width: 300px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}

.text2 {
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}*/

.chatbox {
  width: 100%;
  min-width: 10vw;
  height: calc(100% - 120px);
  /*height: 65vh;*/
  /*font-family: 'CS ChatThaiUI' !important;*/
  background-color: #27303e !important;
  /*padding: 25px;*/
  /*box-shadow: 0 3px #ccc;*/
}

.centerbox {
  /*font-family: 'CS ChatThaiUI' !important;*/
  /*height: 93vh;*/
  height: calc(100vh - 64px);
  /*background-color: white;*/
  /*background-color: #92959e;*/
  background: #27303e !important;
}

.chatlogs {
  /* padding: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 10px;
  margin-bottom: 0.5vh;
  background: #fdfdfd;
  border-radius: 5px; */
  padding: 15px;
  padding-top: 5px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 10px;
  background: #fdfdfd;
  border-radius: 5px;
}

.chatlogs::-webkit-scrollbar {
  width: 10px;
}

.chatlogs::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}


.chat {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  height: 100%;
  /*margin-bottom: -2vh;*/
  /*margin-bottom: 10px;*/

}

.chat .user-photo {
  width: 60px;
  height: 60px;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.chat .user-photo img {
  width: 100%
}

.centerimage {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.chat .chat-message {
  font-size: 16px;
  position: relative;
  display: inline-block;
  clear: both;
  margin-bottom: 8px;
  padding: 13px 14px;
  vertical-align: top;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
}

.chat .chat-message:before {
  position: absolute;
  top: 19px;
  display: block;
  width: 8px;
  height: 6px;
  content: '\00a0';
  -moz-transform: rotate(29deg) skew(-35deg);
  -ms-transform: rotate(29deg) skew(-35deg);
  -webkit-transform: rotate(29deg) skew(-35deg);
  transform: rotate(29deg) skew(-35deg);
}

/*.boxfriend{*/
/*background: #C4E0F9;
 text-align: left;
 padding: 10px;
 margin: 5px 10px 0;
 margin-right: 7vw;
 max-width: 22em;*/
/* float: left;
  color: #fff;
  background-color: #00b0ff;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  -moz-animation-name: slideFromLeft;
  -webkit-animation-name: slideFromLeft;
  animation-name: slideFromLeft;
}
.boxfriend:before{
  left: -3px;
  background-color: #00b0ff;
}*/
/*.boxself{*/
/*max-width: 22em;
 padding: 10px;
 margin: 5px 10px 0;
 margin-left: 7vw;
 background: #1da1f2;
 text-align: right;
 order: -1;*/
/*  float: right;
  color: #1a1a1a;
  background-color: #eceff1;
  -webkit-align-self: flex-end;
  align-self: flex-end;
  -moz-animation-name: slideFromRight;
  -webkit-animation-name: slideFromRight;
  animation-name: slideFromRight;
}
.boxself:before {
  right: -3px;
  background-color: #eceff1;
}*/

.chat-form {
  display: flex;
  align-items: flex-start;
  /*background-color: red;*/
  /*margin-top: 1vh;*/
  margin-bottom: 1vh;
}

.chat-form textarea {
  background: #fbfbfb;
  width: 90% !important;
  height: 50px;
  border: 2px solid rgb(155, 155, 155);
  border-radius: 3px;
  resize: none;
  padding: 10px;
  font-size: 18px;
  color: #333;
}

.chat-form textarea:focus {
  background: #fff;
  /*background-color: red;*/
}

.chat-form textarea::-webkit-scrollbar {
  width: 2px;
}

.chat-form textarea::-webkit-scrollbar-thumb {
  /*border-radius: 5px;*/
  background: rgba(0, 0, 0, .1);
}

p .chat-message {
  max-width: 40em;
  /*border: 1px solid #000000;*/
  word-wrap: break-word;
}

.inputWrapper {
  height: 35px;
  width: 40px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  /*Using a background color, but you can use a background image to represent a button*/
  background-color: #2196f3;
  margin: 5px 10px 0;
  border-radius: 5px;

}

.fileInput {
  cursor: pointer;
  /*height: 100%;*/
  position: absolute;
  /*top: 0;*/
  /*right: 0;*/
  z-index: 99;
  /*This makes the button huge. If you want a bigger button, increase the font size*/
  /*font-size:50px;*/
  /*Opacity settings for all browsers*/
  opacity: 0;
  -moz-opacity: 0;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0)
}

.word-wrap {
  word-wrap: break-word;
}




.thumbnail {
  max-width: 40%;
}

.italic {
  font-style: italic;
}

.small {
  font-size: 0.8em;
}

/** LIGHTBOX MARKUP **/

.lightbox {
  /** Default lightbox to hidden */
  display: none;

  /** Position and style */
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}

.lightbox img {
  /** Pad the lightbox image */
  max-width: 90%;
  max-height: 80%;
  margin-top: 2%;

}

.lightbox:target {
  /** Remove default browser outline */
  outline: none;

  /** Unhide lightbox **/
  display: block;
}

/** {
  margin: 0px;
  padding: 0px;
}*/
.boxselfsticker {
  text-align: right;
  /*margin: 20px auto;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  padding: 10px;
  float: right;
  max-width: 15vw;
}

.boxfriendsticker {
  text-align: left;
  /* margin: 20px auto; */
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  /*border-radius: 20px;*/
  /*background: #efefef;*/
  padding: 10px;
  /*position: relative;
  word-wrap: break-word;*/
  /*margin-top: 0px !important;*/
  float: left;
  max-width: 15vw;
}

.boxselffile {
  text-align: right;
  /*margin: 20px auto;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 15px;
  /*padding: 10px;*/
  font-weight: 300;
  color: black;
  text-align: right;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 25vw;
}

.boxfriendfile {
  text-align: left;
  /*margin: 20px auto;*/
  /*margin-left: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  /*background: #efefef;*/
  color: black;
  /*padding: 10px;*/
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  float: left;
  max-width: 25vw;
}

.boxself {
  text-align: left;
  /*margin: 20px auto;*/
  /*margin-right: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  /*text-align: right;*/
  /*margin-right: 1.5vw;*/
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  /*display: table-cell;*/
  /*display: inline-block;*/
  float: right;
  /*margin: 5px 45px 5px 20px;*/
  max-width: 25vw;
}

.boxfriend {
  text-align: left;
  /* margin: 20px auto; */
  /*margin-left: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  /*margin-top: 0px !important;*/
  /*display: table-cell;*/
  /*display: inline-block;*/
  float: left;
  /*margin: 5px 45px 5px 20px;*/
  max-width: 25vw;
}

.boxfriendquestion {
  text-align: left;
  /* margin: 20px auto; */
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  /*display: table-cell;*/
  /*display: inline-block;*/
  float: left;
  /*margin: 5px 45px 5px 20px;*/
  max-width: 40vw;
}

/* speech bubble 13 */

.sbself:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 15px solid #53ceff;
  border-right: 15px solid transparent;
  border-top: 15px solid #53ceff;
  border-bottom: 15px solid transparent;
  right: -20px;
  top: 14px;


  /*content: "\00a0";
  display: block;
  height: 16px;
  position: absolute;
  top: 11px;
  transform:             rotate( 29deg ) skew( -35deg );
      -moz-transform:    rotate( 29deg ) skew( -35deg );
      -ms-transform:     rotate( 29deg ) skew( -35deg );
      -o-transform:      rotate( 29deg ) skew( -35deg );
      -webkit-transform: rotate( 29deg ) skew( -35deg );
  width:  20px;

  box-shadow: -2px 2px 2px 0 rgba( 178, 178, 178, .4 );
  left: -9px;*/

}


/*.boxfriend  {
  margin-top: 0px !important;
}*/
/* speech bubble 14 */

.sbfriend:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 15px solid transparent;
  border-right: 15px solid #d4d7d8;
  border-top: 15px solid #d4d7d8;
  border-bottom: 15px solid transparent;
  left: -20px;
  top: 13px;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.imgmessage {
  cursor: pointer;
}

.imgmessage:hover {
  opacity: 0.8;
}

.text {
  white-space: nowrap;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 5vh;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CSChatThai', sans-serif !important;
}

.chat-messages {
  padding: 9px;
  /*padding-bottom: 1px !important;*/
  /*margin-top: 2vh;*/
  height: 120px;
  width: 50% !important;

  background: #27303e;
  bottom: 0;
  position: fixed;
  /*border: solid;*/
  /*border-color: #cfd2d4;*/
  /*border-width: 1px;*/
}

.chat-messages textarea {
  width: 100%;
  border: none;
  padding: 10px 20px;
  font: 14px/22px "Lato", Arial, sans-serif;
  margin-bottom: 0px;
  border-radius: 5px;
  resize: none;

}

.chat-messages .buttonsend {
  float: right;
  /*color: blue;*/
  font-size: 16px;
  text-transform: none;
  border: none;
  cursor: pointer;
  /*font-weight: bold;*/
  background: none;
  color: white;
  border-radius: 5px;
}

.chat-messages .buttonsend :hover {
  color: darken($blue, 7%);
  /*color: red;
    background: white;*/
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

.chat-messages .textareabg {
  background: white;
  width: 100% !important;
  height: 70px !important
}

/*.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}
.conversation-start span {
  font-size: 10px;
  display: inline-block;
  color: #999;
}
.conversation-start span:before, .conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 33vh;
  height: 1px;
  content: '';
  background-color: #e6e6e6;
}
.conversation-start span:before {
  left: 0;
}
..conversation-start span:after {
  right: 0;
}*/

.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}

.conversation-start span {
  border-style: solid;
  font-size: 10px;
  display: inline-block;
  color: #777777;
  border-width: thin;
  border-radius: 10px;
  width: 80px;
}

.conversation-start span:before,
.conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 120px;
  height: 1px;
  content: '';
}

.conversation-start span:before {
  left: 0;
}

.conversation-start span:after {
  right: 0;
}

.fixed-content {
  min-height: 100%;
  overflow: hidden;
  top: 0;
  bottom: 0;
}

.iconchat:hover {
  color: #52ceff;
}

.chip.chip--outline:hover {
  background: #52ceff40;
}

.icon {
  font-size: 20px !important;
}

.application a {
  color: #1976d2;
}

/* The Modal (background) */
.modalc {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 9;
  /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw;
  /* Full width */
  height: 100vh;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9);
  /* Black w/ opacity */
  /*background-color: white;*/
}

/* Modal Content (Image) */
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  width: 80%;
  width: auto;
  height: 70vh;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

#headcaption {
  margin: auto;
  display: block;

  /*width: 80%;*/
  /*max-width: 100vw;*/
  text-align: left;
  color: white;
  /*padding-left: 15vw ;*/
  padding-top: 1vh;
  padding-bottom: 1vh;
  /*background-color: white;*/
  background-color: #1b232d;
  /*height: 150px;*/
}

/* Add Animation - Zoom in the Modal */
/*.modal-contentc {
    animation-name: zoom;
    animation-duration: 0.6s;
}*/

@keyframes zoom {
  from {
    transform: scale(0)
  }

  to {
    transform: scale(1)
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 0vh;
  right: 35px;
  color: white;
  font-size: 35px;
  /*font-weight: bold;*/
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-contentc {
    width: 100vw;
  }
}


.wrapper {
  position: relative;
  /*display: inline-block;*/
}

/*
.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
}*/

.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}


.emoji-invoker:hover {
  transform: scale(1.1);
}

.emoji-invoker>svg {
  fill: white;
}



.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 100%;
  height: 20vh;
  /*overflow: scroll;*/
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #ffffffe6;
  box-shadow: 1px 1px 8px #c7dbe6;
}

.emoji-picker__search {
  display: flex;
}

.emoji-picker__search>input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}

.emoji-picker h5 {
  margin-bottom: 0;
  color: #1b232d;
  /*text-transform: uppercase;*/
  font-size: 0.8rem;
  cursor: default;
  font-family: 'CS ChatThaiUI' !important;
}

.emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.emojis:after {
  content: "";
  flex: auto;
}

.emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
  font-size: 30px;
}

.emojis span:hover {
  background: #ececec;
  cursor: pointer;
}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

.menuchat {
  font-size: 30px !important;
  color: black !important;
  cursor: pointer;
  text-align: center;
}

.menuchatword {
  font-size: 16px !important;
  color: black !important;
  cursor: pointer;
  text-align: center;
}

.textemo {
  color: white;
  text-transform: none !important;
  margin-top: 2vh;
  font-size: 13px;
}

.bgsearchcontact {
  background-color: #232a35 !important;
  color: white !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  margin-top: 2vh !important;
  margin-bottom: 2vh !important;
  width: 50% !important;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
}

.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
}

.EndpointUrl {
  display: block;
  color: #fff;
}

.EndpointUrl:hover .urlcopymessage {
  display: inline !important;
}

.urlcopymessage {
  display: none !important;
}



input[type=texteditgroup] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 10px 10px 10px 10px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

.sidebar-menu {
  margin: 0;
  padding: 0;
}

.sidebar-menu ul {
  margin: 0;
  padding: 5px;
}

.sidebar-menu li {
  text-align: center;
  /*width: 32.8%;*/
  width: 20%;
  margin-bottom: 3px !important;
  /*background-color: #b4d2f5;*/
  /*border: 1px solid #eee;*/
  display: inline-block;
  padding: 0;
}

.sidebar-menu i {
  display: block;
  margin: 0 auto 10px auto;
  width: 32px;
  height: 32px;
  margin: 10px auto 0;
  line-height: 32px;
  text-align: center;
  font-size: 20px;
  color: #444444;
  margin-top: 0;
  /*padding-top: 5px;*/
}

.sidebar-menu a {
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
  padding: 0;
  font-size: 13px !important;
  /*border: #2662af solid 1px;*/
  /*background-color: #b4d2f5;*/
  border-radius: 10px;
}

.sidebar-menu a span {
  color: #fdfdfd;
  /*font-size: 10px !important;*/
  padding: 5px 0 10px 0;
  display: block;
  text-transform: uppercase;
  /*font-family:'Josefin Sans';*/
  letter-spacing: 1px;
}
.sidebar-menu a:hover span {
  color: #27303e;
}

.sidebar-menu a:hover i {
  color: #2562ae;
}

.sidebar-menu a:hover {
  font-size: 13px !important;
  background: #ededed;
}


.sidebar-menu li:hover {
  /*width: 25%;*/
}

/*>>> .v-item-group.v-bottom-nav .v-btn:not(.v-btn--active)::before {
    color: red !important;
  }*/

.quick_reply {
  background: white !important;
  text-transform: none;
  font-weight: 200;
  border: #2160b0 1px solid;
  color: #2160b0;
}

.quick_reply:hover {
  background: #1976d240 !important;
}

.quick_replydis {
  background: white !important;
  text-transform: none;
  font-weight: 200;
  border: lightgrey 1px solid;
  color: #2160b0;
}

.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.THSarabun{
  font-family: 'THSarabun', sans-serif !important;
}
.Maitree{
  font-family: 'Maitree', sans-serif !important;
}
.CSChatThai{
  font-family: 'CS ChatThaiUI', sans-serif !important;
}
>>>.v-tabs__container {
  height: 25px;
  background: #27303e !important;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 85px !important;
  height: 83px !important;
  position: relative;
  background: white;
}


.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 90px !important;
  display: -webkit-inline-box !important;
  background: #afafaf3d !important;
  padding-top: 3px !important;
  border-radius: 4px !important;
  width: 100% !important;
  /*margin-bottom: 15px !important;*/
}
[class*='close-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  position: absolute;
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}

</style>



// WEBPACK FOOTER //
// src/components/test.vue